import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { ClickOutsideModule } from 'ng-click-outside';

import { BtrEventApiService } from '@app/shared/services/api';
import { EventCardComponentModule } from '../event-card/event-card.component.module';
import { YourTicketsComponent } from './your-tickets.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    EventCardComponentModule,
    ClickOutsideModule,
  ],
  declarations: [YourTicketsComponent],
  exports: [YourTicketsComponent],
  providers: [BtrEventApiService],
})
export class YourTicketsComponentModule {}
